import {
  GetRewardsCatalogResult,
  GetUserLoyaltyEventsResult,
  GetUserPointsResult,
  GetUserRewardsResult,
  LoyaltyEventDto,
  ToggleUserLoyaltyResult,
  UserRewardStatus,
} from '../api';
import { AppErrorKeys } from '../errors/error';
import { getErrorResponse } from './common';

export const MOCK_POINTS_OK: GetUserPointsResult = {
  totalPoints: 150,
  expiringPoints: 50,
  expirationDate: new Date(new Date().setMonth(new Date().getMonth() + 3)).toISOString(),
};

export const MOCK_POINTS = {
  OK: MOCK_POINTS_OK,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

export const MOCK_CATALOG_OK: GetRewardsCatalogResult = {
  rewardFamilies: [
    {
      label: 'Gourmandises',
      rewards: [
        {
          id: 1,
          description: 'Une boisson chaude offerte au comptoir.',
          label: '1 boisson chaude offert',
          pricePoints: 100,
          imageUrl: '../../../../assets-proxy/rewards/boisson-chaude.jpg',
          thumbUrl: '../../../../assets-proxy/rewards/boisson-chaude.jpg',
        },
        {
          id: 2,
          description: 'Un dessert au choix offert.',
          label: '1 dessert offert',
          pricePoints: 150,
          imageUrl: '../../../../assets-proxy/rewards/dessert.jpg',
          thumbUrl: '../../../../assets-proxy/rewards/dessert.jpg',
        },
        {
          id: 3,
          description: 'Panier garni de fruits et légumes de saison.',
          label: 'Panier de fruits et légumes',
          pricePoints: 400,
          imageUrl: '',
          thumbUrl: '',
        },
        { id: 4, description: 'Une formule petit-déjeuner complète.', label: 'Formule petit déjeuner', pricePoints: 250, imageUrl: '', thumbUrl: '' },
      ],
    },
    {
      label: 'Activités',
      rewards: [
        {
          id: 5,
          description: 'Atelier cuisine pour deux personnes.',
          label: '1 cours de cuisine pour 2',
          pricePoints: 1200,
          imageUrl: '../../../../assets-proxy/rewards/cours-cuisine.jpg',
          thumbUrl: '../../../../assets-proxy/rewards/cours-cuisine.jpg',
        },
        {
          id: 6,
          description: 'Deux places pour le Grand Prix de F1.',
          label: '2 places pour le Grand Prix F1',
          pricePoints: 5000,
          imageUrl: '',
          thumbUrl: '',
        },
      ],
    },
    {
      label: 'Cartes cadeaux',
      rewards: [
        {
          id: 7,
          description: 'Kit complet pour réaliser une baguette française.',
          label: '1 kit french baguette',
          pricePoints: 800,
          imageUrl: '../../../../assets-proxy/rewards/kit-baguette.jpg',
          thumbUrl: '../../../../assets-proxy/rewards/kit-baguette.jpg',
        },
        {
          id: 8,
          description: "Bon d'achat chez Pailhasson.",
          label: "1 bon d'achat Pailhasson",
          pricePoints: 1000,
          imageUrl: '../../../../assets-proxy/rewards/bon-achat-pailhasson.jpg',
          thumbUrl: '../../../../assets-proxy/rewards/bon-achat-pailhasson.jpg',
        },
      ],
    },
  ],
};

export const MOCK_CATALOG = {
  OK: MOCK_CATALOG_OK,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

export const MOCK_USER_REWARDS_OK: GetUserRewardsResult = {
  rewards: [
    {
      id: 1,
      rewardSiteId: 1,
      description: 'Une boisson chaude offerte au comptoir.',
      label: '1 boisson chaude offert',
      imageUrl: '../../../../assets-proxy/rewards/boisson-chaude.jpg',
      thumbUrl: '../../../../assets-proxy/rewards/boisson-chaude.jpg',
      activationDate: new Date(new Date().setDate(new Date().getDate() - 5)).toISOString(),
      expirationDate: new Date(new Date().setMonth(new Date().getMonth() + 1)).toISOString(),
    },
    {
      id: 2,
      rewardSiteId: 2,
      description: 'Un dessert au choix offert.',
      label: '1 dessert offert',
      imageUrl: '../../../../assets-proxy/rewards/dessert.jpg',
      thumbUrl: '../../../../assets-proxy/rewards/dessert.jpg',
      activationDate: new Date(new Date().setDate(new Date().getDate() - 2)).toISOString(),
      expirationDate: new Date(new Date().setMonth(new Date().getMonth() + 2)).toISOString(),
    },
    {
      id: 3,
      rewardSiteId: 3,
      description: 'Panier garni de fruits et légumes de saison.',
      label: 'Panier de fruits et légumes',
      imageUrl: '',
      thumbUrl: '',
      activationDate: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString(),
      expirationDate: new Date(new Date().setMonth(new Date().getMonth() + 3)).toISOString(),
    },
    {
      id: 4,
      rewardSiteId: 4,
      description: 'Une formule petit-déjeuner complète.',
      label: 'Formule petit déjeuner',
      imageUrl: '',
      thumbUrl: '',
      activationDate: new Date().toISOString(),
      expirationDate: new Date(new Date().setMonth(new Date().getMonth() + 1)).toISOString(),
    },
  ],
};

export const MOCK_USER_REWARDS = {
  OK: MOCK_USER_REWARDS_OK,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

const MOCK_ACTIVATE_REWARD_OK = { success: true };

export const MOCK_ACTIVATE_REWARD = {
  OK: MOCK_ACTIVATE_REWARD_OK,
  KO: getErrorResponse(AppErrorKeys.RewardMaxQuantityReached),
};

const MOCK_REDEEM_REWARD_OK = { success: true };

export const MOCK_REDEEM_REWARD = {
  OK: MOCK_REDEEM_REWARD_OK,
  KO: getErrorResponse(AppErrorKeys.RewardAlreadyUsed),
};

const toISOWithRandomTime = (dayOffset: number): string => {
  const d = new Date();
  d.setDate(d.getDate() + dayOffset);
  d.setHours(Math.floor(Math.random() * 24), Math.floor(Math.random() * 60), Math.floor(Math.random() * 60), 0);
  return d.toISOString();
};

const POINTS_TRANSACTIONS: { transactions: LoyaltyEventDto[] } = {
  transactions: [
    {
      id: 1,
      date: toISOWithRandomTime(0),
      type: 'Earned',
      rewardId: undefined,
      rewardTitle: undefined,
      pointsDelta: 50,
    },
    {
      id: 2,
      date: toISOWithRandomTime(-11),
      type: 'Spent',
      rewardTitle: '1 dessert offert',
      rewardStatus: UserRewardStatus.Claimed,
      pointsDelta: -150,
    },
    {
      id: 3,
      date: toISOWithRandomTime(-9),
      type: 'Earned',
      rewardId: undefined,
      rewardTitle: undefined,
      pointsDelta: 50,
    },
    {
      id: 4,
      date: toISOWithRandomTime(-8),
      type: 'Spent',
      rewardTitle: 'Formule petit déjeuner',
      rewardStatus: UserRewardStatus.Expired,
      pointsDelta: -250,
    },
    {
      id: 5,
      date: toISOWithRandomTime(-6),
      type: 'Earned',
      rewardId: undefined,
      rewardTitle: undefined,
      pointsDelta: 50,
    },
    {
      id: 6,
      date: toISOWithRandomTime(-4),
      type: 'Spent',
      rewardTitle: 'Boisson chaude offerte',
      rewardStatus: UserRewardStatus.Active,
      pointsDelta: -100,
    },
    {
      id: 7,
      date: toISOWithRandomTime(-3),
      type: 'Earned',
      rewardId: undefined,
      rewardTitle: undefined,
      pointsDelta: 50,
    },
    {
      id: 8,
      date: toISOWithRandomTime(-1),
      type: 'Earned',
      rewardId: undefined,
      rewardTitle: undefined,
      pointsDelta: 50,
    },
    {
      id: 9,
      date: toISOWithRandomTime(-10),
      type: 'Earned',
      rewardId: undefined,
      pointsDelta: 50,
      rewardTitle: undefined,
    },
    {
      id: 10,
      date: toISOWithRandomTime(-10),
      type: 'Earned',
      rewardId: undefined,
      pointsDelta: 50,
      rewardTitle: undefined,
    },
    {
      id: 11,
      date: toISOWithRandomTime(-10),
      type: 'Earned',
      rewardId: undefined,
      pointsDelta: 50,
      rewardTitle: undefined,
    },
  ],
};

export const MOCK_POINTS_TRANSACTIONS_OK_PAGE0: GetUserLoyaltyEventsResult = {
  hasMore: true,
  events: POINTS_TRANSACTIONS.transactions.slice(0, 9),
};

export const MOCK_POINTS_TRANSACTIONS_OK_PAGE1: GetUserLoyaltyEventsResult = {
  hasMore: false,
  events: POINTS_TRANSACTIONS.transactions.slice(9, 11),
};

export const MOCK_POINTS_TRANSACTIONS = {
  OK_PAGE0: MOCK_POINTS_TRANSACTIONS_OK_PAGE0,
  OK_PAGE1: MOCK_POINTS_TRANSACTIONS_OK_PAGE1,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};

const MOCK_TOGGLE_LOYALTY_OK_SUBSCRIBE: ToggleUserLoyaltyResult = {
  isActive: true,
  lastLoyaltyRegisterDate: new Date().toISOString(),
};

const MOCK_TOGGLE_LOYALTY_OK_UNSUBSCRIBE: ToggleUserLoyaltyResult = {
  isActive: false,
  lastLoyaltyRegisterDate: new Date().toISOString(),
  deactivationDate: new Date().toISOString(),
};

export const MOCK_TOGGLE_LOYALTY = {
  OK_SUBSCRIBE: MOCK_TOGGLE_LOYALTY_OK_SUBSCRIBE,
  OK_UNSUBSCRIBE: MOCK_TOGGLE_LOYALTY_OK_UNSUBSCRIBE,
  KO: getErrorResponse(AppErrorKeys.AnErrorOccured),
};
